/**
 * Debug authentication utility
 * Use this to test if environment variables and headers are working
 */

import {
  ENV,
  getAccessKey,
  isProxyEnabled,
  getGatewayUrl,
} from "../config/env";
import { generateTraceId } from "../utils/uuid";

export async function debugServerGroupCall(centerId: string) {
  console.log("=== DEBUG: Server Group API Call ===");

  // Step 1: Check environment
  const accessKey = getAccessKey();
  console.log("1. Environment Check:");
  console.log(
    "   - Access Key from config:",
    accessKey ? `${accessKey}` : "NOT SET"
  );
  console.log("   - ENV.ACCESS_KEY:", ENV.ACCESS_KEY || "NOT SET");

  if (!accessKey) {
    console.error("❌ CRITICAL: No access key available!");
    return;
  }

  // Step 2: Build request
  const traceId = generateTraceId();
  //const useProxy = isProxyEnabled();
  const endpoint = `${getGatewayUrl()}/matrixGw/center-operations/server-group`;

  console.log("2. Request Configuration:");
  //console.log('   - Use Proxy:', useProxy);
  console.log("   - Endpoint:", endpoint);
  console.log("   - Trace ID:", traceId);

  const headers = {
    "Content-Type": "application/json",
    "trace-id": traceId,
    "access-key": accessKey,
  };

  const body = {
    centerid: centerId,
  };

  console.log("3. Request Headers:");
  Object.entries(headers).forEach(([key, value]) => {
    if (key === "access-key") {
      console.log(`   - ${key}: ${value}`);
    } else {
      console.log(`   - ${key}: ${value}`);
    }
  });

  console.log("4. Request Body:", JSON.stringify(body));

  // Step 3: Make request
  console.log("5. Sending request...");

  try {
    const response = await fetch(endpoint, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    console.log("6. Response:");
    console.log("   - Status:", response.status, response.statusText);
    console.log(
      "   - Headers:",
      Object.fromEntries(response.headers.entries())
    );

    const responseText = await response.text();
    console.log("   - Body:", responseText);

    // Try to parse as JSON
    try {
      const responseData = JSON.parse(responseText);
      console.log("7. Parsed Response:", responseData);

      if (responseData.code === "SUCCESS") {
        console.log("✅ API call successful!");
      } else {
        console.log("⚠️ API returned error:", responseData.message);
      }
    } catch (e) {
      console.log("7. Response is not JSON");
    }
  } catch (error) {
    console.error("❌ Network error:", error);
  }

  console.log("=== END DEBUG ===");
}

// Make available globally
(window as any).debugServerGroupCall = debugServerGroupCall;

export default debugServerGroupCall;
